export default "__VITE_ASSET__559c5791__"